<template>
  <div>
    <v-container class="pt-3 pb-6 px-6">

      <!-- Floating Button -->
      <floating-button @click="computerCreate()" v-if="authUser"/>

      <!-- Confirmation -->
      <confirmation
        v-if="authUser"
        v-model="dialog"
        title="Eliminar PC Autorizado"
        text="Desea eliminar el PC autorizado"
        :item="computerToDelete.name"
        @close="dialog = false"
        @confirm="deleteComputer()"
      />

      <!-- Page Header -->
      <page-header
        title="PC's Autorizados"
        icon="mdi-laptop"
        divider="-"
        :breadcrumbs="breadcrumbs.items"
        refresh
        @refresh="loadComputers()"
      ></page-header>

      <!-- Content -->
      <v-row align="center" justify="center">
        <!-- Table -->
        <v-col cols="12">
          <!-- Loading Bar -->
          <v-progress-linear
            indeterminate
            v-if="isLoadingData"
          ></v-progress-linear>
          <!-- Table -->
          <v-data-table
            v-if="authUser"
            :headers="headers"
            :items="filteredComputers"
            :items-per-page="5"
            class="elevation-1"
            :search="filterInput"
            :footer-props="{
              'items-per-page-options': [5, 15, 30, 50]
            }"
          >
            <!-- Top -->
            <template v-slot:top>
              <v-toolbar flat color="white">
                <!-- State Filter -->
                <v-select
                  v-model="filterState"
                  :items="stateItems"
                  class="shrink mr-5"
                  label="Estado"
                  clearable
                  hide-details
                  single-line
                ></v-select>
                <!-- Input Filter -->
                <v-text-field
                  v-model="filterInput"
                  class="grow"
                  label="Buscar..."
                  prepend-icon="mdi-magnify"
                  clearable
                  single-line
                  hide-details 
                ></v-text-field>
              </v-toolbar>
            </template>
            <!-- Actions -->
            <template v-slot:item.action="{ item }">
              <v-icon class="mr-2" @click="computerEdit(item.id)">mdi-pencil</v-icon>
              <v-icon @click="deleteComputerDialog(item)">mdi-delete</v-icon>
            </template>
            <!-- State -->
            <template v-slot:item.is_active="{ item }">
              <v-chip
                :color="item.is_active ? 'primary' : 'deep-orange'"
                :class="{'white--text': !item.is_active}"
              >{{ item.is_active ? 'Activo' : 'Inactivo' }}</v-chip>
            </template>
            <!-- No Data -->
            <template v-slot:no-data>
              No hay elementos
            </template>
            <!-- No Results -->
            <template v-slot:no-results>
              No hay elementos
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FloatingButton from "@/components/FloatingButton";
import Confirmation from "@/components/Confirmation";
import PageHeader from "@/components/PageHeader";
import Util from "@/util/index";

export default {
  components: {
    FloatingButton,
    Confirmation,
    PageHeader
  },
  data: () => ({
    authUser: false,
    isLoadingData: false,
    dialog: false,
    computerToDelete: {},
    filterInput: '',
    filterState: null,
    stateItems: [
      { text: 'Activo', value: 'true' },
      { text: 'Inactivo', value: 'false' }
    ],
    headers: [
      {
        text: 'Nombre',
        align: 'center',
        sortable: true,
        value: 'name'
      },
      {
        text: 'Dirección MAC',
        align: 'center',
        sortable: true,
        value: 'mac_address'
      },
      {
        text: 'Estado',
        align: 'center',
        sortable: true,
        value: 'is_active'
      },
      {
        text: 'Acción',
        align: 'center',
        sortable: false,
        value: 'action'
      }
    ],
    breadcrumbs: {
      items: [
        { text: "Configuración", disabled: true },
        { text: "PC's Autorizados", disabled: true }
      ]
    }
  }),
  computed: {
    computers () {
      return this.$store.state.computers.computers
    },
    filteredComputers () {
      return this.filterState
        ? this.computers.filter(element => {
          return element.is_active.toString().includes(this.filterState)
        }) : this.computers
    }
  },
  methods: {
    deleteComputerDialog (computer) {
      this.computerToDelete = computer
      this.dialog = !this.dialog
    },
    deleteComputer () {
      var id = this.computerToDelete.id
      this.$store.dispatch('computers/deleteComputer', id)
        .then(() => {
          this.$toast("PC autorizado borrado correctamente.", {
            color: "success",
            x: "center",
            y: "top",
            icon: "mdi-information"
          });
          this.loadComputers()
        })
        .catch(error => {
          var errorToastMessage = "Ha ocurrido un error eliminando el PC autorizado."
          Util.showErrorToast(this, error, errorToastMessage);
        })
        .finally(() => {
          this.dialog = !this.dialog
        })
    },
    computerCreate () {
      this.$router.push({
        name: "computer-create"
      });
    },
    computerEdit (id) {
      this.$router.push({
        name: "computer-edit",
        params: { id: id }
      });
    },
    loadComputers () {
      this.isLoadingData = true;
      this.$store.dispatch('computers/getComputers')
        .then(() => {
          this.authUser = true
        })
        .catch(error => {
          if (error.response.status === 403 ) {
            this.$toast("Su perfil de usuario no tiene los permisos suficientes para acceder a esta funcionalidad del sistema.", {
              color: "error",
              x: "center",
              y: "top",
              icon: "mdi-information",
              timeout: 0,
              showClose: true,
              closeText: "Cerrar"
            });
            this.$router.push({ name: 'home'})
          } else {
            var errorToastMessage = "Ha ocurrido un error cargando los PCs autorizados."
            Util.showErrorToast(this, error, errorToastMessage);
          }
        })
        .finally(() => {
          this.isLoadingData = false;
        });
    }
  },
  created () {
    this.loadComputers()
  }
}
</script>
